import BreadcrumbHome from "../../components/BreadcrumbHome";
import "./OrderPipelinePage.scss";
import OrderPipeline from "../../components/OrderPipeline";
import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router";
import NotFound from "../../components/HttpError/NotFound";

const OrderPipelinePage = () => {
  const { tab } = useParams();
  const [selectedTab, setSelectedTab] = useState(0);
  const [defaultTab, setDefaultTab] = useState(0);
  const [breadcrumbItem, setBreadcrumbItem] = useState("");

  const breadcrumbItems = [
    {
      label: "External Submission",
      value: "Home",
      elementKey: "submission",
      text: "Home",
      url: `/`,
    },
    {
      label: "External Submission",
      elementKey: "submission",
      text: "Order Pipeline",
      disabled: true,
    },
    {
      label: "External Submission",
      elementKey: "submission",
      text: breadcrumbItem,
      disabled: true,
    },
  ];
  const onTabChange = (key: number) => {
    setSelectedTab(key);
  };

  const validTabs = [
    "estimates",
    "orders",
    "approvals",
    "cancelled-orders",
    "returns",
    "recoveries",
    "auto-transact",
  ];

  const getTabIndex = (tabName: string | undefined): number => {
    const tabMap: Record<string, number> = {
      estimates: 0,
      orders: 1,
      approvals: 2,
      "cancelled-orders": 3,
      returns: 4,
      recoveries: 5,
      "auto-transact": 6,
    };
    return tabMap[tabName || "estimates"] ?? -1;
  };

  const getTabName = (tabIndex: number): string => {
    const nameMap: Record<number, string> = {
      0: "Estimates",
      1: "Orders",
      2: "Approvals",
      3: "Cancelled Orders",
      4: "Returns",
      5: "Recoveries",
      6: "Auto Transact",
    };
    return nameMap[tabIndex] || "Estimates";
  };

  useEffect(() => {
    const tabIndex = getTabIndex(tab);
    setDefaultTab(tabIndex);
    setBreadcrumbItem(getTabName(tabIndex));
  }, [tab]);

  // Redirect to default tab if no tab parameter is provided
  if (!tab) {
    return <Navigate to="/order-pipeline/estimates" replace />;
  }

  // Show NotFound page if tab parameter is invalid
  if (tab && !validTabs.includes(tab)) {
    return <NotFound />;
  }

  return (
    <div className="order-pipeline-main-container-wrapper">
      <section className="commercial-hub-header-banner">
        <div className="commercial-hub-header-content">
          <div className="breadcrumb-grid">
            <BreadcrumbHome
              items={breadcrumbItems}
              ariaLabel="Breadcrumb navigation"
            />
          </div>
          <h1 className="commercial-hub-header-title">Order Pipeline</h1>
        </div>
      </section>
      <div className="workspace-container">
        <OrderPipeline
          setSelectedTabHome={() => onTabChange(selectedTab)}
          defaultTab={defaultTab}
        />
      </div>
    </div>
  );
};

export default OrderPipelinePage;
